import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Callout/Callout.tsx
import { jsx } from "react/jsx-runtime";
function cls(...parts) {
  return parts.filter(Boolean).join(" ");
}
var calloutVariants = cva("buyscout-callout", {
  variants: {
    color: {
      neutral: "buyscout-callout--color-neutral",
      success: "buyscout-callout--color-success",
      warning: "buyscout-callout--color-warning",
      error: "buyscout-callout--color-error"
    },
    size: {
      sm: "buyscout-callout--size-sm",
      md: "buyscout-callout--size-md"
    }
  },
  defaultVariants: {
    color: "neutral",
    size: "md"
  }
});
function Callout({ ref, color, size, className, ...props }) {
  return /* @__PURE__ */ jsx("div", { ref, className: calloutVariants({ color, size, className }), ...props });
}
Callout.displayName = "Callout";
function CalloutIcon({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("span", { ref, ...props, "aria-hidden": "true", className: cls("buyscout-callout__chip", className) });
}
CalloutIcon.displayName = "CalloutIcon";
function CalloutContent({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("div", { ref, className: cls("buyscout-callout__content", className), ...props });
}
CalloutContent.displayName = "CalloutContent";
function CalloutTitle({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("span", { ref, className: cls("buyscout-callout__title", className), ...props });
}
CalloutTitle.displayName = "CalloutTitle";
function CalloutBody({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("p", { ref, className: cls("buyscout-callout__body", className), ...props });
}
CalloutBody.displayName = "CalloutBody";
function CalloutList({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("ul", { ref, className: cls("buyscout-callout__list", className), ...props });
}
CalloutList.displayName = "CalloutList";
function CalloutActions({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("div", { ref, className: cls("buyscout-callout__actions", className), ...props });
}
CalloutActions.displayName = "CalloutActions";
export {
  Callout,
  CalloutActions,
  CalloutBody,
  CalloutContent,
  CalloutIcon,
  CalloutList,
  CalloutTitle
};
//# sourceMappingURL=Callout.mjs.map